export const soffFEVersion = '1.6.0-20261104.2';
